import state from './moduleReminderManagementState.js'
import mutations from './moduleReminderManagementMutations.js'
import actions from './moduleReminderManagementActions.js'
import getters from './moduleReminderManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
